import { render, staticRenderFns } from "./doctorDetail.vue?vue&type=template&id=2993c9fc&"
import script from "./doctorDetail.vue?vue&type=script&lang=js&"
export * from "./doctorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports